/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/sharedDeviceProtectionStatusMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a SharedDeviceProtectionStatus. */
export class SharedDeviceProtectionStatus {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a SharedDeviceProtectionStatus.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Consumer Security Api Manager to update a the health status of specific device based on
   * the information
   * @summary Updates the device health status based on the information and deviceId provided.
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<Models.SharedDeviceProtectionStatusUpdateDeviceHealthStatusResponse>
   */
  updateDeviceHealthStatus(deviceId: string, options?: Models.SharedDeviceProtectionStatusUpdateDeviceHealthStatusOptionalParams): Promise<Models.SharedDeviceProtectionStatusUpdateDeviceHealthStatusResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  updateDeviceHealthStatus(deviceId: string, callback: coreHttp.ServiceCallback<Models.DeviceWideProtectionStatus>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  updateDeviceHealthStatus(deviceId: string, options: Models.SharedDeviceProtectionStatusUpdateDeviceHealthStatusOptionalParams, callback: coreHttp.ServiceCallback<Models.DeviceWideProtectionStatus>): void;
  updateDeviceHealthStatus(deviceId: string, options?: Models.SharedDeviceProtectionStatusUpdateDeviceHealthStatusOptionalParams | coreHttp.ServiceCallback<Models.DeviceWideProtectionStatus>, callback?: coreHttp.ServiceCallback<Models.DeviceWideProtectionStatus>): Promise<Models.SharedDeviceProtectionStatusUpdateDeviceHealthStatusResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      updateDeviceHealthStatusOperationSpec,
      callback) as Promise<Models.SharedDeviceProtectionStatusUpdateDeviceHealthStatusResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const updateDeviceHealthStatusOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/devices/{deviceId}/status",
  urlParameters: [
    Parameters.deviceId
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.DeviceWideProtectionStatus
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.DeviceWideProtectionStatus
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
